<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                    <el-button v-if="companyLayout" :disabled="!companyLayout.permission.createPolicy" @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_documentManagment_policy_add')}} {{btnText}}</el-button>
                </div>
                <el-table
                        max-height="650"
                        :data="tableData"
                        @row-click="rowClick"
                        :empty-text="$t('general_noData')"
                        style="width: 100%">
                    <el-table-column
                      label="ID"
                      type="index"
                      width="50">
                    </el-table-column>
                    <el-table-column
                            prop="number"
                            :label="$t('settings_documentManagment_sop_no')"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="revision"
                            :label="$t('settings_documentManagment_sop_revision')"
                            width="70"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            :label="$t('settings_documentManagment_policy_name')">
                    </el-table-column>
                    <el-table-column
                            prop="createDate"
                            :label="$t('settings_documentManagment_sop_createDate')"
                            width="150">
                    </el-table-column>
                    <!-- <el-table-column
                            prop="content"
                            label="Сontent">
                    </el-table-column> -->
                    <el-table-column
                            width="120"
                            :label="$t('settings_documentManagment_policy_operation')">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    v-if="companyLayout"
                                    :disabled="!companyLayout.permission.updatePolicy"
                                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    icon="el-icon-delete"
                                    v-if="companyLayout"
                                    :disabled="!companyLayout.permission.deletePolicy"
                                    @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <sweet-modal blocking :title="`${$t('settings_documentManagment_policy_add')} ${btnText}`" ref="openModal" class="modal" v-on:close="closeModal" width="auto">

            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input :label="paleceholderText + ` ${$t('modal_documentManagment_policy_name')}`" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item prop="number">
                    <el-input :label="$t('modal_documentManagment_policy_number')" v-model.number="form.number"></el-input>
                </el-form-item>
                <el-form-item prop="content">
                    <!-- <el-input type="textarea" :placeholder="paleceholderText + ' content'" v-model="form.content"></el-input> -->
                    <vue2-custom-editor
                      ref="editor"
                      v-model="form.content">
                    </vue2-custom-editor>
                </el-form-item>

                <el-row>
                  <el-col :span="12">
                    <el-form-item>
                      <el-checkbox :disabled="form.checkboxTask" v-model="form.checkboxLogin">{{$t('modal_documentManagment_policy_userMustSignOnTask')}}</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                      <el-checkbox :disabled="form.checkboxLogin" v-model="form.checkboxTask">{{$t('modal_documentManagment_policy_userMustSignOnLogin')}}</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                      <el-checkbox v-if="form.checkboxLogin || form.checkboxTask" v-model="form.period">{{$t('modal_documentManagment_policy_setReviewPeriod')}}</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                      <el-input-number v-if="form.period" v-model="form.days" :min="1"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!-- file -->
                    <el-form-item>
                      <label for="filePolicyAdd" class="file">
                        <i class="el-icon-upload"></i>
                          {{$t('modal_documentManagment_policy_uploadFile')}}
                      </label>
                      <input ref='file' v-show="false" @change="handleFile" id="filePolicyAdd" name="myFile" type="file">

                      <div v-for="list in fileList" :key="list.id" class="file__item">
                        <div class="file__name">{{list.name}}</div>
                        <div class="file__delete" @click="deleteFile(list, 'add')"><i class="el-icon-close"></i></div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('openModal')">{{$t('modal_documentManagment_policy_cancel')}}</el-button>
                    <el-button @click="addItem('form')" type="primary">{{$t('modal_documentManagment_policy_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <sweet-modal blocking :title="`${$t('modal_documentManagment_policy_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit" width="auto">

            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input :label="paleceholderText + ` ${$t('modal_documentManagment_policy_name')}`" v-model="formEdit.name"></el-input>
                </el-form-item>
                <el-form-item prop="number">
                    <el-input :label="$t('modal_documentManagment_policy_number')" v-model.number="formEdit.number"></el-input>
                </el-form-item>

                <el-select v-model="policyRevisionId" :placeholder="$t('modal_documentManagment_policy_revision')" style="width: 100%; margin-bottom: 22px;">
                  <el-option v-for="item in policyRevisionList"
                    :key="item.revision"
                    :label="item.revision !== 0 ? `${item.name} (${$t('modal_documentManagment_policy_revision')}: ${item.revision})` : `${item.name} (Original Document)`"
                    :value="item.revision"
                    @click.native="setRevision(item)">
                  </el-option>
                </el-select>

                <el-form-item prop="content">
                    <!-- <el-input type="textarea" :placeholder="paleceholderText + ' content'" v-model="formEdit.content"></el-input> -->
                    <vue2-custom-editor
                      ref="editor"
                      v-model="formEdit.content">
                    </vue2-custom-editor>
                </el-form-item>

                <el-form-item>
                  <el-input v-model="formEdit.editMessage" type="textarea" :placeholder="$t('modal_documentManagment_policy_note')" maxlength="255" show-word-limit></el-input>
                </el-form-item>

                <el-row>
                  <el-col :span="12">
                    <el-form-item>
                      <el-checkbox :disabled="formEdit.checkboxTask" v-model="formEdit.checkboxLogin">{{$t('modal_documentManagment_policy_userMustSignOnTask')}}</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                      <el-checkbox :disabled="formEdit.checkboxLogin" v-model="formEdit.checkboxTask">{{$t('modal_documentManagment_policy_userMustSignOnLogin')}}</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                      <el-checkbox v-if="formEdit.checkboxLogin || formEdit.checkboxTask" v-model="formEdit.period">{{$t('modal_documentManagment_policy_setReviewPeriod')}}</el-checkbox>
                    </el-form-item>
                    <el-form-item>
                      <el-input-number v-if="formEdit.period" v-model="formEdit.days" :min="1"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!-- file -->
                    <el-form-item>
                      <label for="filePolicyEdit" class="file">
                        <i class="el-icon-upload"></i>
                          {{$t('modal_documentManagment_policy_uploadFile')}}
                      </label>
                      <input ref='file' v-show="false" @change="handleFile" id="filePolicyEdit" name="myFile" type="file">

                      <div v-for="list in fileList" :key="list.id" class="file__item">
                         <div v-if="list.url" class="file__item__viewed">
                         <span @click="viewFile(`${list.url}`)">
                            <i class="el-icon-view"  style="margin-right:10px;"></i>
                            <span class="file__name">{{list.name}}</span>
                         </span>
                             <div class="file__delete" @click="deleteFile(list, 'edit')"><i class="el-icon-close"></i></div>
                         </div>
                         <div v-else class="file__item__not-loaded">
                             <div class="file__name">{{list.name}}</div>
                             <div class="file__delete" @click="deleteFile(list, 'edit')"><i class="el-icon-close"></i></div>
                         </div>
                        </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('openModalEdit')">{{$t('modal_documentManagment_policy_cancel')}}</el-button>
                    <el-button @click="editItem('formEdit')" type="primary">{{$t('modal_documentManagment_policy_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!--VIEWER-->
        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>

        <DocumentInfo ref="DocumentInfo"/>
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment');
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Vue2CustomEditor from "../../vue-2-custom-editor";
  import Media from '@dongido/vue-viaudio'
  import fileImg from '../../fileImg'
  import DocumentInfo from "./documentModalInfo/index"

  export default {
    components: {
      // Header,
      // Menu,
      SweetModal,
      fileImg,
      Media,
      Vue2CustomEditor,
      DocumentInfo,
    },
    watch: {
      'form.period'(val) {
        if (!val) {
          this.form.days = 0
        }
      },
      'formEdit.period'(val) {
        if (!val) {
          this.formEdit.days = 0
        }
      },
      'form.checkboxLogin'(val) {
        if (!val) {
          this.form.period = false
        }
      },
      'form.checkboxTask'(val) {
        if (!val) {
          this.form.period = false
        }
      },
      'formEdit.checkboxLogin'(val) {
        if (!val) {
          this.formEdit.period = false
        }
      },
      'formEdit.checkboxTask'(val) {
        if (!val) {
          this.formEdit.period = false
        }
      }
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    data() {
      return {
        fileList: [],
        deletedId: '',

        paleceholderText: this.$i18n.t('settings_documentManagment_policy_policy'),
        btnText:this.$i18n.t('settings_documentManagment_policy_policy'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        serviceIndex: null,
        form:{
          name: '',
          number: null,
          content: '',
          type: 1,
          checkboxLogin: false,
          checkboxTask: false,
          period: false,
          days: 0,
        },

        policyRevisionList: [],
        policyRevisionId: null,

        formEdit:{
          name: '',
          number: null,
          content: '',
          type: 1,
          checkboxLogin: false,
          checkboxTask: false,
          editMessage: '',
          period: false,
          days: 0,
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          content: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          number: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          content: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          number: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        viewerType: 0,
        fileUrl: '',
        type: ''
      }
    },
    methods: {
      setRevision: function (item) {
        this.formEdit.name = item.name;
        this.formEdit.number = item.number;
        this.formEdit.content = item.content;
        this.formEdit.editMessage = item.editMessage;
        this.formEdit.type = item.type;
        this.formEdit.period = item.period ? true : false;
        this.formEdit.days = item.date;
        this.fileList = item.files;
        this.levelItem(item.level)
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      handleFile(e) {
        console.log('---', e.target.files[0]);
        let file = e.target.files[0];
        this.fileList.push(e.target.files[0]);
        console.log('---', this.fileList);
        this.$refs.file.value = ''
      },
      deleteFile(file, type) {
        let index = this.fileList.indexOf(file);
        if (index !== -1) {
          this.fileList.splice(index, 1);
        }

        if (type == 'edit') {
          if (this.deletedId.length > 0) {
            this.deletedId = this.deletedId + ',' + file.id
          } else {
            this.deletedId = this.deletedId + file.id
          }
        }
      },
      level(login, task) {
        if (!login && !task) {
          return 0
        } else if (login && !task) {
          return 1
        } else if (!login && task) {
          return 2
        }
      },
      levelItem(level) {
        if (level == 0) {
          this.formEdit.checkboxLogin = false;
          this.formEdit.checkboxTask = false
        } else if (level == 1) {
          this.formEdit.checkboxLogin = true;
          this.formEdit.checkboxTask = false
        } else if (level == 2) {
          this.formEdit.checkboxLogin = false;
          this.formEdit.checkboxTask = true
        }
      },
      // * List
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/document/list?companyId=${this.$route.query.companyId}&documentType=policy`)
            .then(response => {
                this.tableData = response.data.list;
                for (let i = 0; i < this.tableData.length; i++) {
                  this.tableData[i].createDate = this.tableData[i].createDate ? moment(this.tableData[i].createDate * 1000).format("D MMM YY") : '';
                }
                loader.hide()
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let level = this.level(this.form.checkboxLogin, this.form.checkboxTask)

            let formData = new FormData();
            formData.append('name', this.form.name);
            formData.append('number', this.form.number);
            formData.append('content', this.form.content);
            formData.append('type', this.form.type);
            formData.append('level', level);
            formData.append('period', this.form.period ? 1 : 0);
            formData.append('date', this.form.days);

            for (let i = 0; i < this.fileList.length; i++) {
              formData.append('file', this.fileList[i]);
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/document/create?companyId=${this.$route.query.companyId}&documentType=policy`, formData)
              .then(response => {
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.policyId,
                    entityTypeId: 54 // policy
                  })
                }
                this.$refs.openModal.close();
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      openModalAdd(){
        this.form.name = '';
        this.form.number = null;
        this.form.content = '';
        this.form.checkboxLogin = false;
        this.form.checkboxTask = false;
        this.form.period = false;
        this.form.period = 0;
        this.fileList = [];
        this.deletedId = '';
        this.$refs.openModal.open()
      },
      closeModal(){
        this.form.name = '';
        this.form.content = '';
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = '';
        this.formEdit.content = '';
        this.formEdit.editMessage = '';
        this.policyRevisionId = null;
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(index, row) {
        this.fileList = [];
        this.deletedId = '';
        this.selectedRowId = row.id;

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/document/item?companyId=${this.$route.query.companyId}&documentId=${row.id}&documentType=policy`)
          .then(response => {
            this.$refs.openModalEdit.open();
            this.formEdit.name = response.data.item.name;
            this.formEdit.number = response.data.item.number;
            this.policyRevisionList = response.data.item.policyRevision;
            this.formEdit.content = response.data.item.content;
            this.formEdit.editMessage = response.data.item.editMessage;
            this.formEdit.type = response.data.item.type;
            this.formEdit.period = response.data.item.period ? true : false;
            this.formEdit.days = response.data.item.date;
            this.fileList = response.data.item.files;
            this.fileList.forEach((item) => {
              item.name = item.originalName
            })
            this.levelItem(response.data.item.level);

            this.policyRevisionId = this.policyRevisionList[this.policyRevisionList.length - 1].revision
            this.$nextTick(() => {
              this.$refs['editor'].setImagesState()
            })
            loader.hide()
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let level = this.level(this.formEdit.checkboxLogin, this.formEdit.checkboxTask);

            let formData = new FormData();
            formData.append('name', this.formEdit.name);
            formData.append('number', this.formEdit.number);
            formData.append('content', this.formEdit.content);
            formData.append('editMessage', this.formEdit.editMessage);
            formData.append('type', this.formEdit.type);
            formData.append('level', level);
            formData.append('period', this.formEdit.period ? 1 : 0);
            formData.append('date', this.formEdit.days);
            formData.append('deletedId', this.deletedId);

            for (let i = 0; i < this.fileList.length; i++) {
              if (!this.fileList[i].id) {
                formData.append('file', this.fileList[i]);
              }
              // formData.append('file', this.fileList[i]);
            }

            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/document/update?companyId=${this.$route.query.companyId}&documentId=${this.selectedRowId}&documentType=policy`, formData)
              .then(response => {
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.policyId,
                    entityTypeId: 54 // policy
                  })
                }
                if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                this.$refs.openModalEdit.close();
                this.loadList();
                loader.hide()
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        this.selectedRowId = row.id;

        this.$confirm(`${this.$t('modal_documentManagment_policy_thisWillPermanentlyDeleteTheTemplatesContinue')}`, `${this.$t('general_warning')}`, {
          confirmButtonText: `${this.$t('general_ok')}`,
          cancelButtonText: `${this.$t('general_cancel')}`,
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: `${this.$t('general_deleteCompleted')}`
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/document/delete?companyId=${this.$route.query.companyId}&documentId=${this.selectedRowId}&documentType=policy`)
            .then(response => {
              this.loadList();
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `${this.$t('general_deleteCanceled')}`
          });
        });
      },
      showMenu() {
        this.open = true;
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false;
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      viewFile(url){
        let type = url.split('.').pop().toUpperCase()
        if (type == 'GIF' || type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF' || type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX') {
          this.fileUrl = url;
          this.type = this.fileUrl.split('.').pop().toUpperCase();
          console.log('---', this.fileUrl, this.type);

          if (type == 'GIF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (type == 'OGG' || type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl;
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }else if (type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX'){
            const win = window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.fileUrl}`, '_blank');
            win.focus();
          }
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      rowClick(row, column, event) {
        if (column.label !== 'Action') {
          this.row = row
          row.docType = 'policy'
          this.$refs.DocumentInfo.openModal(row);
        }
      },
    },
    // watch:{
    //   tableData(val){
    //     val.forEach(i =>{
    //       i.createDate = moment(i.createDate.toString(), 'X').format('DD MMMM YYYY')
    //     })
    //   }
    // }
  }
</script>

<style lang="scss" scoped>
  .setting-component{
    min-width:810px;
      /deep/.sweet-modal{
          max-width:none !important;
          min-width:700px;
      }
  }

  .file {
    cursor: pointer;
    &__item {
      display: flex;
        &__viewed{
            display:flex;
            align-items:center;
            cursor:pointer;
        }
        &__not-loaded{
            display:flex;
            align-items:center;
        }
    }
    &__name {
      margin-right: 10px;
    }
    &__delete {
      color: red;
      cursor: pointer;
    }
  }
</style>
